module.exports = __webpack_public_path__ + "img/outstream.5e30694e.svg";